var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146.531,
    height: 45.791,
    viewBox: "0 0 146.531 45.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.295,
    y1: 1.172,
    x2: 0.551,
    y2: 0.189,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ad1d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.076,
    y1: 2.062,
    x2: 0.914,
    y2: 1.357,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24bbb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.34,
    x2: 0.5,
    y2: 1.429,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.11,
    y1: -0.934,
    x2: 0.902,
    y2: 0.123,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#712b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea1d27"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M141.952,45.791H4.579A4.593,4.593,0,0,1,0,41.212V4.579A4.593,4.593,0,0,1,4.579,0H141.952a4.593,4.593,0,0,1,4.579,4.579V41.212A4.593,4.593,0,0,1,141.952,45.791Z",
    fill: "#00081e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M9.8,21.279V9.259A1.254,1.254,0,0,1,10.945,8a1.709,1.709,0,0,1,1.145.343L34.184,20.478a.954.954,0,0,1,0,1.832L12.09,34.444a2.248,2.248,0,0,1-1.145.343A1.254,1.254,0,0,1,9.8,33.528Z",
    transform: "translate(1.419 1.158)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    d: "M23.994,21.394,10.6,8h.229a1.709,1.709,0,0,1,1.145.343l16.256,8.929Z",
    transform: "translate(1.535 1.158)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    "data-name": "Path 3354",
    d: "M26.421,24.257,22.3,20.136,26.536,15.9l5.838,3.205a.954.954,0,0,1,0,1.832Z",
    transform: "translate(3.228 2.302)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M10.7,32.879h0L23.979,19.6,28.1,23.721,11.959,32.536a1.841,1.841,0,0,1-1.259.343Z",
    transform: "translate(1.549 2.838)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M75.823,36.2a5.482,5.482,0,0,1-1.259-1.717l1.832-.8a10.56,10.56,0,0,0,.572.916,2.826,2.826,0,0,0,1.832.916,2.621,2.621,0,0,0,1.946-.916,3.548,3.548,0,0,0,.572-1.946v-.687c-1.374,1.717-4.236,1.488-5.838-.343a5.072,5.072,0,0,1,0-6.754c1.717-1.717,4.236-1.946,5.724-.343h0v-.8H83.15V32.31a4.96,4.96,0,0,1-1.832,4.236,4.225,4.225,0,0,1-2.633.8A5.253,5.253,0,0,1,75.823,36.2Zm47.966.458h0l1.946-4.579-3.434-7.9h1.946l2.4,5.609,2.4-5.609H131L125.735,36.66Zm-9.273-4.35h0a3.022,3.022,0,0,1-.8-2.175A2.6,2.6,0,0,1,114.4,28.3a4.415,4.415,0,0,1,3.205-1.145,3.92,3.92,0,0,1,2.061.458,1.944,1.944,0,0,0-2.061-1.946,2.116,2.116,0,0,0-1.946,1.259l-1.717-.687a3.635,3.635,0,0,1,3.549-2.29,3.883,3.883,0,0,1,2.976,1.145,4.222,4.222,0,0,1,.916,2.976v4.808h-1.946v-.8a3.565,3.565,0,0,1-1.03.8,3.656,3.656,0,0,1-1.6.343,4.42,4.42,0,0,1-2.29-.916ZM53.5,28.188h0a4.753,4.753,0,0,1,4.808-4.808,4.829,4.829,0,0,1,4.808,4.808,4.808,4.808,0,1,1-9.616,0Zm10.3,0h0a4.753,4.753,0,0,1,4.808-4.808,4.829,4.829,0,0,1,4.808,4.808A4.753,4.753,0,0,1,68.611,33,4.829,4.829,0,0,1,63.8,28.188ZM40.564,30.707h0a7.534,7.534,0,0,1,.114-10.532A7.268,7.268,0,0,1,45.945,18a7.1,7.1,0,0,1,5.037,2.061l-1.374,1.488a5.114,5.114,0,0,0-7.327.114,5.531,5.531,0,0,0,0,7.67,5.191,5.191,0,0,0,7.556.114,4.119,4.119,0,0,0,1.03-2.519H46.059V24.869h6.754a7.04,7.04,0,0,1,.114,1.6A6.594,6.594,0,0,1,51.1,31.05,7.019,7.019,0,0,1,46.174,33a8.5,8.5,0,0,1-5.609-2.29Zm48.424.8h0a5.223,5.223,0,0,1,0-6.869,4.164,4.164,0,0,1,6.182,0,6.785,6.785,0,0,1,1.259,2.175l-6.3,2.633a2.442,2.442,0,0,0,2.29,1.488,2.593,2.593,0,0,0,2.4-1.374l1.717,1.145h0a3.035,3.035,0,0,0-.572.687,5.013,5.013,0,0,1-6.983.114Zm11.906,1.374h0V20.175h4.121a4.111,4.111,0,0,1,4.35,3.778,3.837,3.837,0,0,1-3.892,3.778h-2.518v5.037l-2.061.114Zm9.616,0h0V20.175h1.946V32.882Zm-25.872-.229h0v-14.2H86.7v14.2ZM119.554,29.1h0a3.121,3.121,0,0,0-1.832-.458c-1.374,0-2.175.687-2.175,1.488a1.44,1.44,0,0,0,1.6,1.259,2.392,2.392,0,0,0,2.4-2.29Zm-58.612-.916h0a2.642,2.642,0,1,0-5.266,0,2.708,2.708,0,0,0,2.633,2.862,2.785,2.785,0,0,0,2.633-2.862Zm10.3,0h0a2.642,2.642,0,1,0-5.266,0,2.642,2.642,0,1,0,5.266,0Zm10.188.8h0a.421.421,0,0,1,.114-.343h0v-1.03c0-.114-.114-.343-.114-.458a2.656,2.656,0,0,0-2.4-1.946,2.78,2.78,0,0,0-2.518,2.862,2.719,2.719,0,0,0,2.633,2.862c.916.114,1.832-.687,2.29-1.946Zm8.357-1.03h0l4.236-1.832a1.91,1.91,0,0,0-1.717-1.03A2.775,2.775,0,0,0,89.79,27.96ZM107.3,24.067h0a1.992,1.992,0,0,0-2.175-1.946h-2.29v4.007h2.4A2.052,2.052,0,0,0,107.3,24.067Z",
    transform: "translate(5.57 2.606)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M114.314,32.314H114.2V32.2h0v.114h.114Z",
    transform: "translate(16.533 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M114.3,32.314Zm0-.114Z",
    transform: "translate(16.548 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M114.3,32.314h0V32.2h0Z",
    transform: "translate(16.548 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M114.3,32.314Zm0-.114Z",
    transform: "translate(16.548 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M114.3,32.2h0v.114h0Z",
    transform: "translate(16.548 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M114.3,32.314h0V32.2h0Z",
    transform: "translate(16.548 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M114.3,32.311Zm0,0Z",
    transform: "translate(16.548 4.665)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M114.4,32.314Zm0-.114Zm0,.114Z",
    transform: "translate(16.562 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M114.4,32.2h0v.114h0Z",
    transform: "translate(16.562 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M114.4,32.314h0V32.2h0Z",
    transform: "translate(16.562 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M114.4,32.314Zm0-.114Z",
    transform: "translate(16.562 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M114.4,32.311Z",
    transform: "translate(16.562 4.665)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M114.511,32.314Zm0-.114h0c0,.114-.114.114,0,0Z",
    transform: "translate(16.566 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M114.5,32.314V32.2h0v.114h0V32.2h0v.114h0V32.2h0Z",
    transform: "translate(16.576 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M114.5,32.314Zm0-.114Z",
    transform: "translate(16.576 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M114.5,32.311Z",
    transform: "translate(16.576 4.665)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M114.614,32.2h0v.114h0Z",
    transform: "translate(16.576 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M114.6,32.314h0V32.2h0Z",
    transform: "translate(16.591 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M114.6,32.314Zm0-.114Z",
    transform: "translate(16.591 4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M38.9,10.52A3.185,3.185,0,0,1,42.22,7.2a3.043,3.043,0,0,1,2.633,1.374l-.916.572a2.067,2.067,0,0,0-1.717-.8,2.136,2.136,0,0,0-2.175,2.29,2.136,2.136,0,0,0,2.175,2.29,2.257,2.257,0,0,0,1.488-.572v-1.03H41.876v-1.03h3.091v2.4a3.35,3.35,0,0,1-2.633,1.145A3.28,3.28,0,0,1,38.9,10.52Z",
    transform: "translate(5.632 1.042)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M45.4,13.711V7.3h4.35V8.33H46.43v1.6h3.205v1.03H46.43v1.832h3.32v1.03l-4.35-.114Z",
    transform: "translate(6.573 1.057)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M52.246,13.711V8.33H50.3V7.3h5.037V8.33H53.391v5.38Z",
    transform: "translate(7.282 1.057)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M58.1,13.711V7.3h1.145v6.411Z",
    transform: "translate(8.411 1.057)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M62.046,13.711V8.33H60.1V7.3h5.037V8.33H63.191v5.38Z",
    transform: "translate(8.701 1.057)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M67.7,10.52a3.32,3.32,0,0,1,6.64,0,3.186,3.186,0,0,1-3.32,3.32A3.251,3.251,0,0,1,67.7,10.52Zm5.38,0a2.076,2.076,0,0,0-2.175-2.29,2.2,2.2,0,0,0-2.175,2.29,2.076,2.076,0,0,0,2.175,2.29A2.133,2.133,0,0,0,73.08,10.52Z",
    transform: "translate(9.801 1.042)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M79.065,13.711l-3.32-4.579v4.579H74.6V7.3h1.145l3.32,4.465V7.3h1.145v6.411Z",
    transform: "translate(10.8 1.057)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.5197c7096dc7adbfc4963b5e7067d04d.svg";
export { ForwardRef as ReactComponent };